export default "__VITE_ASSET__BWTnoH0I__"